import React, { useEffect, useRef, useState } from 'react';
import { IoSend } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { FormattedMessage, useIntl } from 'react-intl';

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import useApi from '../../hooks/useApi';
import { network_tl } from '../../translations';

const Container = () => {
    const [chat, setChat] = useState([]);
    const [prompt, setPrompt] = useState("");
    const [loading, setLoading] = useState(false);
    const [chatId, setChatId] = useState(null);
    const [error, setError] = useState(null);
    const [showRedirect, setShowRedirect] = useState(false);
    const containerRef = useRef();
    const navigate = useNavigate();
    const intl = useIntl();
    const { Axios } = useApi();
    
    useEffect(() => {
        const container = containerRef.current;
        container.scrollTop = container.scrollHeight;
    }, [chat]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!prompt.trim()) return;

        const userMessage = { role: 'user', content: prompt };
        setChat(prev => [...prev, userMessage]);
        setLoading(true);
        setError(null);
        setPrompt("");

        try {
            const response = await Axios.post(`api/ai-chatbot/`, {
                new_chat: chatId === null,
                user_message: prompt,

            });
            
                const assistantMessage = {
                    role: 'assistant',
                    content: response.data.payload.assistant_message
                };
                setChat(prev => [...prev, assistantMessage]);
                
                if (response.data.payload.id && !chatId) {
                    setChatId(response.data.payload.id);
                }

                if (response.data.payload.assistant_message.toLowerCase().includes("let me find you the best match")) {
                    setShowRedirect(true);
                    let timer = setTimeout(() => {
                        navigate("/recommendations")

                    }, 4000)
                    return () => clearTimeout(timer);
                }
            
        } catch (e) {
            let errorMessage = '';
            if (axios.isCancel(e)) {
                errorMessage = "Request was cancelled";
            } else if (e.response) {
                errorMessage = e.response.data.description || errorMessage;
            } else if (e.request) {
                errorMessage = network_tl(intl);
            }

            setChat(prev => [...prev, {
                role: 'assistant',
                content: errorMessage
            }]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='flex flex-col h-full  overflow-auto'>
            {/* Header */}
            <div className='flex-shrink-0 items-center w-[90%] sm:w-[80%] md:w-[60%] mx-auto justify-between px-4 py-5 border-b-2 border-gray-200 bg-white rounded-xl flex'>
                <h2 className='text-lg font-semibold text-black'><FormattedMessage id="ai_assistant" defaultMessage="AI Assistant" /></h2>
                {/* <button
                    onClick={toggleChat}
                    className='text-white hover:text-gray-200 transition-colors'
                >
                    <IoClose size={22} />
                </button> */}
            </div>

            {/* Messages */}
            <div
                ref={containerRef}
                className='   mx-auto w-full flex-grow overflow-y-auto mb-4 p-4 space-y-4 bg-base-bg '
            >
                <div className='w-[90%] sm:w-[80%] md:w-[60%] mx-auto h-full '>
                {chat.length === 0 ? (
                    <div className='h-full flex flex-col items-center justify-center text-center p-8'>
                        <div className="mx-auto w-16 h-16 rounded-full bg-primary flex items-center justify-center mb-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-8 w-8 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                />
                            </svg>
                        </div>
                        <h3 className='font-medium text-gray-800 mb-1'><FormattedMessage id="ai_assistant_desc" defaultMessage="How can I help you today?" /></h3>
                        {error && (
                            <p className="text-red-500 text-sm mt-2">{error}</p>
                        )}
                    </div>
                ) : (
                    <>
                        {chat.map((message, index) => (
                            <div
                                key={index}
                                className={`flex mb-4 ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
                            >
                                <div
                                    className={`max-w-[85%] rounded-xl px-4 py-3 ${message.role === 'user'
                                            ? 'bg-primary text-white rounded-tr-none'
                                            : 'bg-white text-gray-800 shadow-sm rounded-tl-none border border-gray-100'
                                        }`}
                                >
                                    <p className='text-sm' dangerouslySetInnerHTML={{ __html: message.content }}></p>
                                </div>
                            </div>
                        ))}
                        {showRedirect && (
                            <div className="flex justify-center">
                                <div className=" text-primary px-4 py-2 rounded-lg text-sm">
                                    <FormattedMessage 
                                        id="redirecting" 
                                        defaultMessage="Redirecting..." 
                                    />
                                </div>
                            </div>
                        )}
                        {/* {error && (
                            <div className="flex justify-center">
                                <p className="text-red-500 text-sm bg-red-50 px-3 py-1 rounded-lg">{error}</p>
                            </div>
                        )} */}
                    </>
                )}

                {/* Loading bubble */}
                {loading && (
                    <div className='flex justify-start'>
                        <div className='bg-white shadow-sm rounded-2xl rounded-bl-none px-4 py-3 border border-gray-100'>
                            <div className='flex items-center py-3 space-x-1'>
                                <div className='w-2 h-2 rounded-full bg-gray-400 animate-bounce' style={{ animationDelay: '0ms' }} />
                                <div className='w-2 h-2 rounded-full bg-gray-400 animate-bounce' style={{ animationDelay: '150ms' }} />
                                <div className='w-2 h-2 rounded-full bg-gray-400 animate-bounce' style={{ animationDelay: '300ms' }} />
                            </div>
                        </div>
                    </div>
                )}
                </div>
            </div>

            {/* Input Form */}
            <form onSubmit={handleSubmit} className='p-4 border-t  w-[90%] sm:w-[80%] md:w-[60%] mx-auto border-gray-100 bg-white rounded-xl'>
                <div className='flex items-center space-x-2'>
                    <input
                        type="text"
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        placeholder={intl.formatMessage({ id: "type_a_message", defaultMessage: "Type a message" })}
          className="flex-1 border border-gray-200 text-xs sm:text-base rounded-full py-2 px-4 focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-primary/30 !bg-base-bg"
                        disabled={loading}
                    />
                    <button
                        type="submit"
                        disabled={loading || !prompt.trim()}
                        className={`p-3 rounded-full ${loading || !prompt.trim()
                                ? 'text-gray-400'
                                : 'text-white bg-primary hover:bg-primary-dark shadow-md'
                            } transition-all`}
                    >
                        <IoSend size={16} />
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Container;